import { AppRoute } from "../types/routes";

export function getRouteFromHash(hash: string): AppRoute {
  const raw = hash.replace(/^#\/?/, "").trim();
  const [pathPart, queryPart = ""] = raw.split("?");
  const originalParts = pathPart.split("/").filter(Boolean);
  const normalizedPath = pathPart.toLowerCase();
  const parts = normalizedPath.split("/").filter(Boolean);
  const [rawSegment, rawParam, rawExtra, rawTail] = parts;
  const [, , originalExtra] = originalParts;
  const segment = (rawSegment || "").split("?")[0].trim();
  const param = (rawParam || "").split("?")[0].trim();
  const extra = (rawExtra || "").split("?")[0].trim();
  const tail = (rawTail || "").split("?")[0].trim();
  const query = new URLSearchParams(queryPart);

  if (!segment) return { name: "home" };
  if (segment === "admin" && param === "ligas" && !extra) return { name: "adminLeagues" };
  if (segment === "ligas" && !param) return { name: "leagues" };
  const leagueIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  if (segment === "ligas" && leagueIdPattern.test(param) && !extra) {
    return { name: "leagueDetail", leagueId: param };
  }
  if (segment === "organizador" && param === "ligas" && leagueIdPattern.test(extra) && tail === "participantes" && parts.length === 4) {
    return { name: "leagueParticipants", leagueId: extra };
  }
  if (segment === "organizador" && param === "ligas" && !tail) {
    if (!extra) return { name: "organizerLeagues" };
    if (extra === "nova") return { name: "leagueEditor" };
    if (leagueIdPattern.test(extra)) return { name: "leagueEditor", leagueId: extra };
  }
  if (segment === "s") {
    if (param === "partidas" && extra) {
      const matchId = Number(extra);
      if (Number.isFinite(matchId) && matchId > 0) {
        return { name: "matchDetail", matchId };
      }
    }
    if (param === "jogadores" && extra) {
      const playerId = Number(extra);
      if (Number.isFinite(playerId) && playerId > 0) {
        return { name: "publicPlayerProfile", playerId };
      }
    }
    if (param === "ranking") return { name: "rankingOfficial" };
    if (param === "torneios" && extra) {
      const challengeId = Number(extra);
      if (Number.isFinite(challengeId) && challengeId > 0) {
        return { name: "tournamentDetail", challengeId };
      }
    }
    if (param === "desafios" && extra) {
      const challengeId = Number(extra);
      if (Number.isFinite(challengeId) && challengeId > 0) {
        return { name: "challengeDetail", challengeId };
      }
    }
  }
  if (segment === "sobre") return { name: "about" };
  if (segment === "login") return { name: "login" };
  if (segment === "cadastro") return { name: "register" };
  if (segment === "pagamento" && (param === "sucesso" || param === "success")) {
    return { name: "paymentSuccess" };
  }
  if (segment === "confirmar-email" || segment === "confirm-email") {
    return {
      name: "confirmEmail",
      token: String(query.get("token") || "").trim() || undefined,
    };
  }
  if (
    segment === "redefinir-senha" ||
    segment === "reset-password" ||
    segment === "nova-senha"
  ) {
    return {
      name: "resetPassword",
      token: String(query.get("token") || "").trim() || undefined,
    };
  }
  if (segment === "perfil" && !param) return { name: "profileUser" };
  if (segment === "perfil" && param === "admin") return { name: "profileAdmin" };
  if (
    segment === "atletas" ||
    segment === "athletes" ||
    ((segment === "jogadores" || segment === "jogador") && !param)
  ) {
    return { name: "athletes" };
  }
  if ((segment === "partidas" || segment === "matches") && !param) {
    return { name: "matches" };
  }
  if ((segment === "partidas" || segment === "matches") && param) {
    const matchId = Number(param);
    if (Number.isFinite(matchId) && matchId > 0) {
      return { name: "matchDetail", matchId };
    }
  }
  if ((segment === "clubes" || segment === "clubs") && !param) {
    return { name: "clubs" };
  }
  if ((segment === "clubes" || segment === "clubs") && param) {
    return { name: "clubDetail", clubSlug: decodeURIComponent(rawParam || "") };
  }
  if ((segment === "jogadores" || segment === "jogador") && param) {
    const playerId = Number(param);
    if (Number.isFinite(playerId) && playerId > 0) {
      return { name: "publicPlayerProfile", playerId };
    }
  }
  if (
    segment === "admin" &&
    (param === "criar-desafio" || param === "novo-desafio")
  ) {
    return { name: "adminCreateChallenge" };
  }
  if (
    segment === "admin" &&
    (param === "criar-torneio" || param === "novo-torneio")
  ) {
    return { name: "adminCreateTournament" };
  }
  if (
    segment === "admin" &&
    (
      param === "tela-inicial" ||
      param === "pagina-inicial" ||
      param === "configuracoes" ||
      param === "home" ||
      param === "conteudo"
    )
  ) {
    return { name: "admin" };
  }
  if (
    segment === "admin" &&
    (param === "desafio" ||
      param === "desafios" ||
      param === "torneio" ||
      param === "torneios") &&
    extra
  ) {
    const challengeId = Number(extra);
    if (Number.isFinite(challengeId) && challengeId > 0) {
      const challengeName = String(query.get("name") || "").trim() || undefined;
      const challengeStatusRaw = String(query.get("status") || "")
        .trim()
        .toLowerCase();
      const challengeTypeRaw = String(query.get("type") || "")
        .trim()
        .toLowerCase();
      const participantsRaw = Number(query.get("participants"));
      const challengeScheduledAtRaw = String(query.get("scheduledAt") || "").trim();
      const challengeStatus: AppRoute["challengeStatus"] =
        challengeStatusRaw === "pending" ||
        challengeStatusRaw === "started" ||
        challengeStatusRaw === "finished"
          ? (challengeStatusRaw as AppRoute["challengeStatus"])
          : undefined;
      const challengeType: AppRoute["challengeType"] =
        challengeTypeRaw === "challenge" ||
        challengeTypeRaw === "super8" ||
        challengeTypeRaw === "poco" ||
        challengeTypeRaw === "tournament"
          ? (challengeTypeRaw as AppRoute["challengeType"])
          : param === "torneio" || param === "torneios"
            ? "tournament"
          : undefined;
      const challengeParticipantsCount =
        Number.isFinite(participantsRaw) && participantsRaw >= 0
          ? Math.floor(participantsRaw)
          : undefined;
      const challengeScheduledAt = challengeScheduledAtRaw || undefined;
      const baseRoute = {
        challengeId,
        challengeName,
        challengeStatus,
        challengeType,
        challengeParticipantsCount,
        challengeScheduledAt,
      };
      if (tail === "resultados" || tail === "resultado") {
        return { name: "adminChallengeResults", ...baseRoute };
      }
      return { name: "adminChallengeEdit", ...baseRoute };
    }
  }
  if (
    segment === "admin" &&
    (param === "torneio" || param === "torneios")
  ) {
    return { name: "adminTournaments" };
  }
  if (segment === "admin") return { name: "admin" };
  if (segment === "politica-privacidade" || segment === "privacidade") {
    return { name: "privacyPolicy" };
  }
  if (segment === "termos-de-uso" || segment === "termos") {
    return { name: "termsOfUse" };
  }
  if (segment === "eventos" && param === "id" && extra) {
    const eventId = decodeURIComponent(String(originalExtra || "")).trim();
    if (eventId) {
      if (tail === "inscricao" || tail === "inscrever" || tail === "inscrever-se") {
        return { name: "eventRegistration", eventId };
      }
      const tournamentMatch = eventId.match(/^ev_t_(\d+)$/i);
      if (tournamentMatch) {
        const challengeId = Number(tournamentMatch[1]);
        if (Number.isFinite(challengeId) && challengeId > 0) {
          return { name: "tournamentDetail", challengeId };
        }
      }
      return { name: "home" };
    }
  }
  if (segment === "eventos" && param) {
    const eventIndex = Number(param);
    if (Number.isFinite(eventIndex) && eventIndex >= 0) {
      if (extra === "inscricao" || extra === "inscrever" || extra === "inscrever-se") {
        return { name: "eventRegistration", eventIndex };
      }
      return { name: "eventDetail", eventIndex };
    }
  }
  if (segment === "loja" && !param) return { name: "shop" };
  if (segment === "loja" && param) return { name: "shopDetail", productId: param };

  if (segment === "ranking" || segment === "tela") {
    if (!param) return { name: "rankingHub" };
    if (
      param === "buscar-organizador" ||
      param === "selecionar-organizador"
    ) {
      return { name: "rankingOrganizersDirectory" };
    }
    const organizerFromParam = Number(param);
    if (Number.isFinite(organizerFromParam) && organizerFromParam > 0) {
      return { name: "rankingOrganizer", organizerUserId: organizerFromParam };
    }
    if (param === "tnp" || param === "oficial" || param === "oficiais") {
      return { name: "rankingOfficial" };
    }
    if (
      (param === "organizador" || param === "organizadores") &&
      extra
    ) {
      const organizerUserId = Number(extra);
      if (Number.isFinite(organizerUserId) && organizerUserId > 0) {
        return { name: "rankingOrganizer", organizerUserId };
      }
    }
    if (param === "organizador" || param === "organizadores") {
      return { name: "rankingOrganizersDirectory" };
    }
    return { name: "rankingHub" };
  }

  if (segment === "challenge" || segment === "challange" || segment === "super-doze") {
    return { name: "challengeSuperTwelve" };
  }

  if ((segment === "desafios" || segment === "desafio") && !param) {
    return { name: "challengesHub" };
  }

  if ((segment === "torneios" || segment === "torneio") && !param) {
    return { name: "tournaments" };
  }
  if (
    (segment === "torneios" || segment === "torneio") &&
    (param === "tnp" || param === "oficial" || param === "oficiais")
  ) {
    return { name: "tournamentsOfficial" };
  }
  if (
    (segment === "torneios" || segment === "torneio") &&
    (param === "organizador" || param === "organizadores") &&
    extra
  ) {
    const organizerUserId = Number(extra);
    if (Number.isFinite(organizerUserId) && organizerUserId > 0) {
      return { name: "tournamentsOrganizer", organizerUserId };
    }
  }
  if (
    (segment === "torneios" || segment === "torneio") &&
    (param === "organizador" || param === "organizadores")
  ) {
    return { name: "tournamentsOrganizers" };
  }
  if (
    (segment === "torneios" || segment === "torneio") &&
    param === "detalhe" &&
    extra
  ) {
    const challengeId = Number(extra);
    const challengeViewGroupRaw = String(query.get("group") || "")
      .trim()
      .toUpperCase();
    const challengeViewGroup =
      challengeViewGroupRaw === "A" || challengeViewGroupRaw === "B"
        ? (challengeViewGroupRaw as "A" | "B")
        : undefined;
    if (Number.isFinite(challengeId) && challengeId > 0) {
      return { name: "tournamentDetail", challengeId, challengeViewGroup };
    }
  }
  if (
    (segment === "desafios" || segment === "desafio") &&
    (param === "buscar-organizador" || param === "selecionar-organizador")
  ) {
    return { name: "challengesOrganizersDirectory" };
  }
  if (
    (segment === "desafios" || segment === "desafio") &&
    (param === "tnp" || param === "oficial" || param === "oficiais")
  ) {
    return { name: "challengesOfficial" };
  }
  if (
    (segment === "desafios" || segment === "desafio") &&
    (param === "organizador" || param === "organizadores") &&
    extra
  ) {
    const organizerUserId = Number(extra);
    if (Number.isFinite(organizerUserId) && organizerUserId > 0) {
      return { name: "challengesOrganizer", organizerUserId };
    }
  }
  if (
    (segment === "desafios" || segment === "desafio") &&
    (param === "organizador" || param === "organizadores")
  ) {
    return { name: "challengesOrganizersDirectory" };
  }
  if (
    (segment === "desafios" || segment === "desafio") &&
    param === "detalhe" &&
    extra
  ) {
    const challengeId = Number(extra);
    const challengeViewGroupRaw = String(query.get("group") || "")
      .trim()
      .toUpperCase();
    const challengeViewGroup =
      challengeViewGroupRaw === "A" || challengeViewGroupRaw === "B"
        ? (challengeViewGroupRaw as "A" | "B")
        : undefined;
    if (Number.isFinite(challengeId) && challengeId > 0) {
      return { name: "challengeDetail", challengeId, challengeViewGroup };
    }
  }
  if ((segment === "desafios" || segment === "desafio") && param === "ranking") {
    return { name: "rankingHub" };
  }
  if ((segment === "desafios" || segment === "desafio") && param === "super-oito") {
    return { name: "challengeSuperEight" };
  }
  if (
    (segment === "desafios" || segment === "desafio") &&
    (param === "super-doze" || param === "challenge" || param === "challange")
  ) {
    return { name: "challengeSuperTwelve" };
  }
  if ((segment === "desafios" || segment === "desafio") && param === "poco") {
    return { name: "challengePoco" };
  }

  return { name: "home" };
}

export function getHashRouteFromSharePath(pathname: string, search = "") {
  const path = String(pathname || "").trim();
  if (!path.startsWith("/s/")) return "";

  const route = getRouteFromHash(`${path}${search || ""}`);
  const suffix = String(search || "");

  if (route.name === "matchDetail" && route.matchId) {
    return `#/partidas/${route.matchId}`;
  }
  if (route.name === "publicPlayerProfile" && route.playerId) {
    return `#/jogadores/${route.playerId}`;
  }
  if (route.name === "rankingOfficial") {
    return `#/ranking/tnp${suffix}`;
  }
  if (route.name === "tournamentDetail" && route.challengeId) {
    return `#/torneios/detalhe/${route.challengeId}${suffix}`;
  }
  if (route.name === "challengeDetail" && route.challengeId) {
    return `#/desafios/detalhe/${route.challengeId}${suffix}`;
  }

  return "";
}
